import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "onChange"];
import clsx from 'clsx';
import React, { forwardRef } from 'react';
import InputField from '../InputField';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styles = {
  "container": "pbui-FYZSB",
  "color": "pbui-5se8V",
  "input": "pbui-Tfn7K"
};
var ColorPicker = /*#__PURE__*/forwardRef(function ColorPicker(props, ref) {
  var className = props.className,
    _onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  var containerClasses = clsx(styles.container, className);
  var colorClasses = clsx(styles.color);
  var inputClasses = clsx(styles.input);
  var _React$useState = React.useState(props.value ? props.value.toString() : '#'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    color = _React$useState2[0],
    setColor = _React$useState2[1];
  return /*#__PURE__*/_jsxs("div", {
    className: containerClasses,
    ref: ref,
    children: [/*#__PURE__*/_jsx("div", {
      className: colorClasses,
      children: /*#__PURE__*/_jsx("input", _extends({
        type: "color",
        className: inputClasses,
        onChange: function onChange(e) {
          if (_onChange) {
            _onChange(e);
            setColor(e.target.value);
          }
        },
        value: color
      }, rest))
    }), /*#__PURE__*/_jsx("div", {
      className: "w-full",
      children: /*#__PURE__*/_jsx(InputField, {
        disabled: true,
        label: "Color",
        value: color
      })
    })]
  });
});
export default ColorPicker;